import _ from 'lodash';
export default function reducer(
  state = {
    List: [],
    StoredList: [],
    Upload: [],
    ForUpload: {},
    CommentUploaded: [],
    Count: {},
    Activities: [],
    CommentList: [],
    CommentCount: {},
    CommentSelected: {},
    FormActive: 'List',
    Selected: {},
    SelectedId: [],
    EditType: '',
    Section: '',
    Loading: 'RETRIEVING',
    Filter: {
      status: 'active',
      fileName: '',
    },
    ActiveTab: 'active',
    DocumentUploadLoading: false,
    Files: [],
    Attachment: [],
    SelectedFields: [],
    LastSelectedIndex: -1,
    SelectedFieldsDragging: [],
    uploadType: null,
    SubFolders: [],
    SelectedFolderOptions: {},
    modalIsLoaded: false,
  },
  action
) {
  switch (action.type) {
    case 'ADD_DOCUMENT_LIST': {
      let List = state.List;
      action.list.map((e) => {
        List.push(e);
      });
      return { ...state, List: List };
    }
    case 'SET_DOCUMENT_LIST': {
      return {
        ...state,
        List: action.list,
        Count: {
          ...(typeof action.count !== 'undefined' ? action.count : state.Count),
        },
      };
    }
    case 'SET_DOCUMENT_STORED_LIST': {
      return {
        ...state,
        StoredList: action.list,
        Count: {
          ...(typeof action.count !== 'undefined' ? action.count : state.Count),
        },
      };
    }
    case 'SET_DOCUMENT_UPLOAD': {
      let upload = state.Upload;
      upload.length = 0;
      upload.push(action.upload);
      return { ...state, Upload: upload };
    }
    case 'SET_DOCUMENT_FOR_UPLOAD': {
      return { ...state, ForUpload: action.ForUpload };
    }

    case 'SET_DOCUMENT_FORM_ACTIVE': {
      return { ...state, FormActive: action.FormActive };
    }
    case 'SET_DOCUMENT_SELECTED': {
      return { ...state, Selected: action.Selected };
    }
    case 'SET_DOCUMENT_EDIT_TYPE': {
      return { ...state, EditType: action.EditType };
    }
    case 'SET_DOCUMENT_LOADING': {
      return { ...state, Loading: action.Loading };
    }
    case 'SET_DOCUMENT_FILTER': {
      const { Filter } = { ...state };
      const updatedFilter = _.merge(
        {},
        _.omit(Filter, action.name),
        action.filter
      );
      return { ...state, Filter: updatedFilter };
    }
    case 'SET_DOCUMENT_UPLOAD_TYPE': {
      return { ...state, uploadType: action.uploadType };
    }
    case 'SET_DOCUMENT_COMMENT_LIST': {
      return {
        ...state,
        CommentList: action.list,
        ...(typeof action.count !== 'undefined'
          ? { CommentCount: action.count }
          : {}),
      };
    }
    case 'CLEAR_DOCUMENT_COMMENT': {
      return { ...state, CommentList: [], CommentCount: {} };
    }
    case 'ADD_DOCUMENT_COMMENT_LIST': {
      const { CommentList } = { ...state };
      const updatedList = _.uniqBy(CommentList.concat(action.list), 'id');

      return {
        ...state,
        CommentList: updatedList,
        ...(typeof action.count !== 'undefined'
          ? { CommentCount: action.count }
          : state.CommentCount),
      };
    }
    case 'SET_DOCUMENT_COMMENT_SELECTED': {
      return { ...state, CommentSelected: action.Selected };
    }
    case 'SET_DOCUMENT_ACTIVITIES_LIST': {
      return { ...state, Activities: action.list };
    }
    case 'SET_DOCUMENT_COMMENT_UPLOAD': {
      return { ...state, CommentUploaded: action.CommentUploaded };
    }
    case 'SET_DOCUMENT_UPLOAD_SECTION': {
      return { ...state, Section: action.Section };
    }
    case 'RESET_DOCUMENT_FILTER': {
      return { ...state, Filter: {} };
    }
    case 'SET_DOCUMENT_ACTIVE_TAB': {
      return { ...state, ActiveTab: action.active };
    }
    case 'SET_DOCUMENT_FILES': {
      return { ...state, Files: action.Files };
    }
    case 'SET_DOCUMENT_ATTACHMENT': {
      return {
        ...state,
        Attachment: action.Attachment,
        Section: action.Section,
      };
    }
    case 'SET_DOCUMENT_ATTACHMENT_SECTION': {
      return { ...state, Section: action.Section };
    }
    case 'SET_DOCUMENT_SELECTED_FIELDS': {
      return {
        ...state,
        ...(action.Selected ? { SelectedFields: action.Selected } : {}),
        ...(action.LastSelectedIndex
          ? { LastSelectedIndex: action.LastSelectedIndex }
          : {}),
      };
    }
    case 'SET_DOCUMENT_FIELDS_DRAGGING': {
      return { ...state, SelectedFieldsDragging: action.Fields };
    }
    case 'UPDATE_DATA_DOCUMENT_LIST': {
      const l = state.List.map((e, i) => {
        if (e.id === action.UpdatedData.id) {
          return action.UpdatedData;
        }
        return e;
      });
      return { ...state, List: l };
    }
    case 'REMOVE_DOCUMENT_FROM_LIST': {
      let l = state.List.filter((e) => {
        return e.id !== action.UpdatedData.id;
      });
      return { ...state, List: l };
    }
    case 'REMOVE_DOCUMENT_FROM_LIST_BULK': {
      var list = _.filter(state.List, (p) => {
        return !_.includes(
          action.list.map((e) => {
            return e.id;
          }),
          p.id
        );
      });
      return { ...state, List: list };
    }
    case 'SET_SUB_FOLDERS': {
      return {
        ...state,
        SubFolders: action.list,
        SelectedFolderOptions: {
          ...state.SelectedFolderOptions,
          [action.selectedFolderId]: action.list,
        },
      };
    }
    case 'RESET_DOCUMENT': {
      return { ...state, ...action };
    }
    case 'DOCUMENT_MODAL_IS_LOADED':
      return {
        ...state,
        modalIsLoaded: action.boolean,
      };
    default:
      return state;
  }
}
